export default "__VITE_ASSET__ErE9Mll7__"